import { toBoolean } from '@/helpers/settings';

const validateList = (list, validators) => {
  if (!Array.isArray(list)) {
    return null
  }

  const validated = []

  list.forEach(item => {
    if (typeof item !== 'object' || !Object.keys(item).length) {
      return
    }

    let failed = false

    validators.forEach(validator => {
      if (failed) {
        return
      }

      const key = typeof validator === 'string' ? validator : validator.key
      const handler = typeof validator === 'string' ? (item, key) => item.hasOwnProperty(key) && item[key] : validator.handler

      if (!handler(item, key)) {
        failed = true
      }
    })

    if (!failed) {
      validated.push(item)
    }
  })

  return validated.length > 0 ? validated : null
}

const validateRequiredValue = value => {
  if (value === undefined || value === null || value.toString() === '') {
    return null
  }

  return !!value ? value : null
}

export default {
  pages_presence: {
    about_us: value => toBoolean(value),
    delivery_and_payment: value => toBoolean(value),
    blog: value => toBoolean(value),
    offers: value => toBoolean(value),
  },

  products: {
    description: value => toBoolean(value),
    display_variant_option_label: value => validateRequiredValue(value),
    cart_button_visibility: value => validateRequiredValue(value),
    cart_button_available: value => validateRequiredValue(value),
    cart_button_unavailable: value => validateRequiredValue(value),
    card_image_aspect_ratio: value => validateRequiredValue(value),
    card_image_object_fit: value => validateRequiredValue(value),
    card_shadow_size: value => validateRequiredValue(value),
    card_shadow_opacity: value => validateRequiredValue(value),
    card_hover_shadow_size: value => validateRequiredValue(value),
    card_hover_shadow_opacity: value => validateRequiredValue(value),
    card_border_width: value => validateRequiredValue(value),
    cards_count_desktop: value => validateRequiredValue(value),
    modifiers_visibility: value => validateRequiredValue(value),
    display_nested_categories: value => validateRequiredValue(value),
  },

  appbars: {
    desktop_variant: value => validateRequiredValue(value),
    mobile_variant: value => validateRequiredValue(value),
    disable_mobile_specific_appbar: value => toBoolean(value),
  },

  sidebar: {
    fixed: value => validateRequiredValue(value),
    variant: value => validateRequiredValue(value),
  },

  search: {
    placeholder: value => validateRequiredValue(value),
  },

  logos: {
    header: value => validateRequiredValue(value),
    footer: value => validateRequiredValue(value),
  },

  delivery: {
    restrict_to_city: value => toBoolean(value),
    extra_address_fields_state: value => validateRequiredValue(value),
    notes_field_state: value => validateRequiredValue(value),
    address_hint: value => validateRequiredValue(value),
  },

  yandex_metrika: {
    yandex_metrika_webvisor: value => toBoolean(value),
    yandex_metrika_ecommerce: value => toBoolean(value),
  },

  feedback_form: {
    name_enabled: value => toBoolean(value),
    message_enabled: value => toBoolean(value),
    contact_type: value => validateRequiredValue(value),
  },

  legal_docs: {
    privacy_policy: value => toBoolean(value),
    personal_data: value => toBoolean(value),
    eula: value => toBoolean(value),
  },

  home_promo: {
    visibility: value => validateRequiredValue(value),
    heading: value => validateRequiredValue(value),
    subheading: value => validateRequiredValue(value),
    background: value => validateRequiredValue(value),
    promo_button: value => validateRequiredValue(value),
    promo_button_visibility: value => validateRequiredValue(value),
  },

  home_features: {
    visibility: value => validateRequiredValue(value),
    order: value => validateRequiredValue(value),
    list: value => validateList(value, ['image', 'title', 'content']),
  },

  home_offers: {
    visibility: value => validateRequiredValue(value),
    order: value => validateRequiredValue(value),
    variant: value => validateRequiredValue(value),
    full_width_variant_card_size: value => validateRequiredValue(value),
    subvariant: value => validateRequiredValue(value),
    display_text: value => toBoolean(value),
    image_aspect_ratio_width: value => validateRequiredValue(value),
    image_aspect_ratio_height: value => validateRequiredValue(value),
    image_brightness_percent: value => validateRequiredValue(value),
    title: value => validateRequiredValue(value),
    subtitle: value => validateRequiredValue(value),
    sorting: value => validateRequiredValue(value),
  },

  home_categories: {
    visibility: value => validateRequiredValue(value),
    order: value => validateRequiredValue(value),
    categories_to_display_select: value => validateRequiredValue(value),
    categories_list: value => validateList(value, ['category_id', 'size']),
    display_names: value => validateRequiredValue(value),
  },

  home_products_collection: {
    visibility: value => validateRequiredValue(value),
    order: value => validateRequiredValue(value),
    title: value => validateRequiredValue(value),
  },

  home_feedback: {
    visibility: value => validateRequiredValue(value),
    order: value => validateRequiredValue(value),
    title: value => validateRequiredValue(value),
    content: value => validateRequiredValue(value),
    label: value => validateRequiredValue(value),
  },

  about_us_promo: {
    display: value => toBoolean(value),
    background: value => validateRequiredValue(value),
    background_gradient: value => toBoolean(value),
    without_context_background: value => toBoolean(value),
    title: value => validateRequiredValue(value),
    content: value => validateRequiredValue(value),
  },

  about_us_cards: {
    display: value => toBoolean(value),
    icon: value => validateRequiredValue(value),
    title: value => validateRequiredValue(value),
    list: value => validateList(value, ['image', 'title', 'content']),
  },

  about_us_technology: {
    display: value => toBoolean(value),
    background: value => validateRequiredValue(value),
    heading: value => validateRequiredValue(value),
    icon: value => validateRequiredValue(value),
    title: value => validateRequiredValue(value),
    description: value => validateRequiredValue(value),
    list: value => validateList(value, ['image']),
  },

  about_us_staff: {
    display: value => toBoolean(value),
    heading: value => validateRequiredValue(value),
    subheading: value => validateRequiredValue(value),
    icon: value => validateRequiredValue(value),
    list: value => validateList(value, ['image', 'title', 'content']),
  },

  about_us_quality: {
    display: value => toBoolean(value),
    title: value => validateRequiredValue(value),
    description: value => validateRequiredValue(value),
    image: value => validateRequiredValue(value),
  },

  about_us_feedback: {
    display: value => toBoolean(value),
    title: value => validateRequiredValue(value),
    content: value => validateRequiredValue(value),
    label: value => validateRequiredValue(value),
  },

  blog_list: {
    title: value => validateRequiredValue(value),
  },

  offers_list: {
    title: value => validateRequiredValue(value),
    description: value => validateRequiredValue(value),
  },

  offer_page: {
    display_cover: value => validateRequiredValue(value),
  },

  offers_menu: {
    title: value => validateRequiredValue(value),
  },

  delivery_payments_delivery: {
    display: value => toBoolean(value),
    display_map: value => toBoolean(value),
    display_zones: value => toBoolean(value),
    display_stocks: value => toBoolean(value),
    definitions: value => validateList(value, ['title', 'content']),
  },

  delivery_payments_payments: {
    display: value => toBoolean(value),
    definitions: value => validateList(value, ['title', 'content']),
  },

  delivery_payments_guarantee: {
    display: value => toBoolean(value),
    definitions: value => validateList(value, ['title', 'content']),
  },
}
